import { lastValueFrom } from "rxjs";
import { createEffect, createResource, createSignal, For } from "solid-js";

import type { UtdoKvp } from "../types";
import { useApi } from "../util/api";
import { toString } from "../util/converters";
import { panic } from "../util/panic";

const keys: Record<string, string> = {
    "intro-image": "Intro: Image (Accueil)",
    "intro-title": "Intro: Titre (Accueil)",
    "intro-text": "Intro: Texte (Accueil)",
    "donations-title": "Encadré supplémentaire: Titre (Accueil)",
    "donations-text": "Encadré supplémentaire: Texte (Accueil)",
    "description": "Description (en bas à gauche)",
    "seo-description": "Description (SEO)",
    "seo-keywords": "Mots-clefs (SEO)",
    "legal": "Mentions légales (Espace-Pro)",
    "style": "Style",
};

export function Values() {
    const api = useApi();

    const [ key, setKey ] = createSignal<string | undefined>();
    const [ date, setDate ] = createSignal<string | undefined>();

    const [ values, { refetch } ] = createResource(
        key,
        async (k) => {
            if (k === undefined) {
                return [] as UtdoKvp[];
            }
            return await lastValueFrom(api.getKvp(k));
        },
        { initialValue: [] as UtdoKvp[] },
    );

    createEffect(() => {
        const val = values();
        if (val.length === 0) {
            return;
        }
        setDate(val[0].date);
    });

    const currentValue = (): string => {
        return values().find((v) => v.date === date())?.value ?? "";
    };

    const selectDate = (d: string) => (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        setDate(d);
    };

    const selectKey = (k: string) => (ev :Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        setKey(k);
    };

    let valueRef!: HTMLTextAreaElement;

    const save = async (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const k = key() ?? "";
        if (k.length === 0) {
            panic("Aucune valeur sélectionnée.");
            return;
        }
        const v = toString(valueRef.value);
        try {
            if (await lastValueFrom(api.setKvp(k, v))) {
                panic(`Valeur "${k}" enregistée avec succès.`);
            }
            refetch();
        } catch (err: any) {
            panic(err);
            return;
        }
    };

    return <section id="admin-values">
        <h2>Valeurs</h2>
        <div>
            <div>
                <div class="keys">
                    <For each={Object.keys(keys)}>
                        {(k) => <button
                            classList={{ accent: key() === k }}
                            onClick={selectKey(k)}>{keys[k]}</button>}
                    </For>
                </div>
            </div>
            <div>
                <div class="dates">
                    <For each={values()}>
                        {(v) => <button
                            classList={{ accent: date() === v.date }}
                            onClick={selectDate(v.date)}>{v.date}</button>}
                    </For>
                </div>
            </div>
            <div>
                <form class="editor" onSubmit={save} autocomplete="off">
                    <textarea
                        ref={valueRef}
                        value={currentValue()}></textarea>
                    <div class="buttons">
                        <button class="accent">Enregister</button>
                    </div>
                </form>
            </div>
        </div>
    </section>;
}